<template>
  <div>
    <Header />
    <main>
      <div class="type">
        <div class="bar --left"></div>
        <div>
          <template v-if="project.type === 'implementation'">
            <img :src="`/icons/${projectTypeIcon.IMPLEMENTATION}-duotone.svg`" :alt="project.type">
          </template>
          <template v-else-if="project.type === 'research'">
            <img :src="`/icons/${projectTypeIcon.RESEARCH}-duotone.svg`" :alt="project.type">
          </template>
          <template v-else-if="project.type === 'design'">
            <img :src="`/icons/${projectTypeIcon.DESIGN}-duotone.svg`" :alt="project.type">
          </template>
          <template v-else>
            <img :src="`/icons/${projectTypeIcon.UNDEFINED}-duotone.svg`" alt="Something's wrong">
          </template>
        </div>
        <div class="bar --right"></div>
      </div>

      <div class="excerpt">
        <h1>{{ project.name }}</h1>
        <div class="html" v-html="project.description"></div>
        <template v-if="project.sort > 1">
          <router-link :to="previous" class="navigation">Previous</router-link>
        </template>
        <template v-if="project.sort < this.projectListLength">
          <router-link :to="next" class="navigation">Next</router-link>
        </template>
      </div>

      <div class="content">
        <div  class="media">
          <img :src="`${mediaPath}${project.image}`" alt="" />
        </div>

        <h2>Role</h2>
        <p>{{ project.role }}</p>

        <h2>Challenges</h2>
        <div class="html" v-html="project.problem"></div>

        <h2>Process & Solution</h2>
        <div class="html" v-html="project.solution"></div>

        <h2>Technologies & Tools</h2>
        <div class="html" v-html="project.tools"></div>

        <div class="btn-group">
          <template v-if="project.sort > 1">
            <router-link :to="previous" class="navigation">Previous</router-link>
          </template>
          <template v-if="project.sort < this.projectListLength">
            <router-link :to="next" class="navigation">Next</router-link>
          </template>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Header from '../components/Header';
import { mapState } from 'vuex';

export default {
  name: 'ProjectDetail',
  title: '',
  components: {
    Header
  },
  data() {
    return {
      previous: '',
      next: '',
      mediaPath: ''
    };
  },
  computed: {
    ...mapState([
      'host',
      'project',
      'projectList',
      'projectTypeIcon'
    ]),
    projectListLength() {
      return this.projectList.length;
    }
  },
  watch: {
    '$route.params': {
      handler() {
        this.getProject();
      },
      immediate: true,
    },
    project() {
      this.setDocTitle();
    }
  },
  methods: {
    getProject() {
      this.$store.dispatch('loadProjectById', {
        router: this.$router,
        id: this.$route.params.id
      });
      this.setPrevNext();
    },
    getProjectIndex() {
      let i = -1;
      this.projectList.forEach((item, index) => {
        if (item.id === this.project.id)
          i = index;
      });
      return i;
    },
    setPrevNext() {
      const i = this.getProjectIndex();
      if (i > 0) {
        this.previous = `/project/${this.projectList[i-1].id}`;
      }
      if (i < (this.projectListLength - 1)) {
        this.next = `/project/${this.projectList[i+1].id}`;
      }
    },
    setDocTitle() {
      document.title = `${this.project.name} | Debye Leong`;
    }
  },
  created() {
    this.mediaPath = `${this.host}/_resources/media/`;
    this.getProject();
    this.setDocTitle();
  }
};
</script>

<style scoped lang="scss">
@import '../assets/css/subpages';
</style>
